import React, { FC, useContext } from 'react'
import { HeaderLogo } from './HeaderLogo'
import { HeaderMenu } from './HeaderMenu'
import { HeaderMenuItem } from './HeaderMenuItem'
import { LocalPath } from '../../common/intl/LocalPath'
import { HeaderActions } from './HeaderActions'
import { HeaderLinkAction } from './HeaderLinkAction'
import { MessagesContext } from '../../common/intl/MessagesContext'

export const Header: FC = () => {
  const messages = useContext(MessagesContext)

  return (
    <div className="overflow-hidden bg-blue-900 text-sm sm:text-base">
      <div className="container flex h-14 items-center justify-between gap-4 py-2 text-blue-50 sm:gap-8">
        <HeaderLogo />

        <HeaderMenu>
          <HeaderMenuItem
            title={messages.webcam?.title}
            to={LocalPath.WebcamTest}
            optionalActivePrefix={LocalPath.Webcam}
          >
            {messages.webcam?.name || 'Webcam'}
          </HeaderMenuItem>

          <HeaderMenuItem
            title={messages.mic?.title}
            to={LocalPath.MicTest}
            optionalActivePrefix={LocalPath.Mic}
          >
            {messages.mic?.name || 'Microphone'}
          </HeaderMenuItem>

          <HeaderMenuItem
            title={messages.headphones?.title}
            to={LocalPath.Headphones}
            partiallyActive={true}
          >
            {messages.headphones?.name || 'Headphones'}
          </HeaderMenuItem>
        </HeaderMenu>

        <HeaderActions>
          <HeaderLinkAction to={LocalPath.Feedback}>
            {messages.feedback?.title || 'Feedback'}
          </HeaderLinkAction>
        </HeaderActions>
      </div>
    </div>
  )
}
